import { Component, OnInit, Renderer2, Inject, ChangeDetectorRef, NgZone } from '@angular/core'; 
import { ActivatedRoute, Router } from "@angular/router" 
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '@services/security';
import { LoaderService } from '@modules/loader';  
import _ from 'lodash'; 
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmChangeEmailRequestModel } from '@shared/security/confirm-changeEmail-request.model';


@Component({
  selector: 'app-confirm-changeEmail',
  templateUrl: './confirm-changeEmail.component.html',
  styleUrls: ['./confirm-changeEmail.component.scss'] 
})
export class ConfirmChangeEmailComponent implements OnInit  {  
    infoMessage:string;  
    oldEmail:string;
    newEmail:string;
    token:string;
    isError:boolean=false;
    submitted:boolean=false; 

  isLoading: boolean;

    constructor(private authService: AuthenticationService,
        private route:ActivatedRoute, 
        private changeDedectionRef :ChangeDetectorRef,
        private loaderService: LoaderService, private renderer: Renderer2,
        private messageService: MessageService,
        @Inject(DOCUMENT) private _document,   private zone: NgZone,private confirmationService : ConfirmationService) {
        }

        
  ngOnInit() {   
    this.token = this.route.snapshot.queryParams["token"];
    this.oldEmail = this.route.snapshot.queryParams["oldEmail"];
    this.newEmail = this.route.snapshot.queryParams["newEmail"];
  }

  ngAfterContentChecked(): void {
    this.changeDedectionRef.detectChanges();
  }  

 _save(){   
  const request = new ConfirmChangeEmailRequestModel();
  request.OldEmail = this.oldEmail;
  request.NewEmail = this.newEmail;
  request.Token = this.token;
  this.submitted = true;
  let successMessage = {severity:'success', summary:"Votre demande a été traité avec succés."};
  let failureMessage = {severity:'error', summary:"Une erreur est survenue lors du traitement de votre demande."};
  this.loaderService.showLoader();
  this.authService.ConfirmUpdateEmail(request).subscribe((response:any)=>{  
       if(response)
          this.messageService.add(successMessage); 
       else
          this.messageService.add(failureMessage);

        this.isLoading = false;
      }); 
  this.loaderService.hideLoader(); 
}

save(){  
 this.submitted = true; 
 this.confirmationService.confirm({
   message: `Voulez-vous vraiment valider votre nouvelle adresse-email ?`,
   accept: () => {
     this.isLoading = true;
     this._save();
   }
 }); 
} 
}